import { render, staticRenderFns } from "./ApplyInfoButton.vue?vue&type=template&id=eec5ddc4"
import script from "./ApplyInfoButton.vue?vue&type=script&lang=js"
export * from "./ApplyInfoButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eec5ddc4')) {
      api.createRecord('eec5ddc4', component.options)
    } else {
      api.reload('eec5ddc4', component.options)
    }
    module.hot.accept("./ApplyInfoButton.vue?vue&type=template&id=eec5ddc4", function () {
      api.rerender('eec5ddc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditorControl/components/ApplyInfoButton.vue"
export default component.exports